import React from "react";
import BasicModal from "../../../../core/BaseComponents/Modal";
import deleteImg from '../../../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";

function DeleteCustomizeWelcomeScreen(props) {

  return (
    <BasicModal
      popupOpen={props?.deleteWelcomeScreenPopUp}
      bodyMessage={<>
        <img src={deleteImg} alt="approve" className="w-40px" />
        <div className="delete-hotel mb-3">{props?.isWelcomeScreenDeletedRef.current?.isWelcomeScreenDeletedModalData ?
          <div className="confirm-delete-hotel">
            <p>Do you really want to Delete Customize Welcome Screen "<b>{props?.isWelcomeScreenDeletedRef.current?.isWelcomeScreenDeletedModalData.row.text}</b>" ?</p>
            <p className="warning"><IoMdWarning /> Warning</p>
            <p>Customize Welcome Screen Configuration "{props?.isWelcomeScreenDeletedRef.current?.isWelcomeScreenDeletedModalData.row.text}" will be permanently deleted <br />
              Deleting the specified Customize Welcome Screen Configuration can't be undone.
            </p>
            <p className="mt-3">To confirm deletion, type "Delete {props?.isWelcomeScreenDeletedRef.current?.isWelcomeScreenDeletedModalData.row.text}"</p>
            <div className="form-group-hotel mt-3">
              <div className="floating-label">
                <input
                  id="deleteHotel"
                  placeholder=''
                  onChange={(e) => props?.setConfirmDeleteWelcomeScreenRow(e.target.value)}
                />
                <label htmlFor="deleteHotel">Delete {props?.isWelcomeScreenDeletedRef.current?.isWelcomeScreenDeletedModalData.row.text}</label>
              </div>
              {(props?.confirmDeleteWelcomeScreenRow === "" && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete {props?.isWelcomeScreenDeletedRef.current?.isWelcomeScreenDeletedModalData.row.text}</small></p>
              ) : (props?.confirmDeleteWelcomeScreenRow !== `Delete ${props?.isWelcomeScreenDeletedRef.current?.isWelcomeScreenDeletedModalData.row.text}` && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete {props?.isWelcomeScreenDeletedRef.current?.isWelcomeScreenDeletedModalData.row.text}</small></p>
              ) : ""
              }
            </div>
          </div> :
          props?.isWelcomeScreenDeletedRef.current?.userConformationModalData?.successMessage}</div>
      </>
      }
      footer={
        props?.isWelcomeScreenDeletedRef.current?.isWelcomeScreenDeletedModalData ?
          {
            primaryButton: {
              buttonName: "Cancel",
              action: props?.popupCloseHandler
            }
            ,
            secondaryButton: {
              buttonName: "Delete",
              action: props?.deleteWelcomeScreenHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: props?.popupCloseHandler
            }
          }
      }
    />
  );
}

export default DeleteCustomizeWelcomeScreen;
